import {
  Avatar,
  Box,
  Button,
  Flex,
  Input,
  Progress,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  keyframes,
} from "@chakra-ui/react";

import moment from "moment";
import React, { useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { CircularProgress } from "@mui/material";
import { CgTrash } from "react-icons/cg";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { CloseIcon } from "@chakra-ui/icons";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const blink = keyframes`
  50% {
    opacity: 0;
  }
`;

function TablePurchased(props) {
  const {
    columnsData,
    tableData,
    pagination,
    nextPage,
    prevPage,
    firstPage,
    lastPage,
    goToPage,
    limitPage,
    type,
    onClickAction,
    loading,
    onDeletePersona,
    justPurchasedHistoryId,
  } = props;

  const [showDialog, setShowDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;

  const onOpenDialog = (id) => {
    setShowDialog(true);
    setSelectedId(id);
  };

  const onCloseDialog = () => {
    setShowDialog(false);
    setSelectedId(null);
  };

  const onConfirmDelete = () => {
    onDeletePersona(selectedId);
    setShowDialog(false);
    setSelectedId(null);
  };

  return (
    <>
      <Flex
        direction="column"
        w={{ md: "100%", lg: "85%" }}
        overflowX={{ sm: "hidden", lg: "hidden" }}
      >
        <Box width="100%" overflowX="auto">
          <Table
            {...getTableProps()}
            variant="simple"
            minWidth={{ sm: "100%", md: "900px" }}
          >
            <Thead bgColor={"#6FE6FC"} borderTopRadius={5}>
              {headerGroups.map((headerGroup, index) => (
                <Tr
                  {...headerGroup.getHeaderGroupProps()}
                  key={`${type}-tr-${index}`}
                >
                  {headerGroup.headers.map((column, index) => (
                    <Th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      pe="10px"
                      key={`${type}-th-${index}`}
                      borderColor="transparent"
                    >
                      <Flex
                        fontSize={{ sm: "xs", md: "sm" }}
                        color="gray.400"
                        alignItems="center"
                        borderTopRadius={5}
                        paddingY={1}
                        px={1}
                        bgColor="#6FE6FC"
                      >
                        <Text
                          textAlign="center"
                          fontWeight="bold"
                          color="#000"
                          fontSize={{ sm: "xs", md: "sm" }}
                        >
                          {column.render("Header")}
                        </Text>
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>

            <Tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()} key={`${type}-tb-tr-${index}`}>
                    {row.cells.map((cell, i) => {
                      let data = "";
                      if (cell.column.Header === "NAME") {
                        if (row.original.is_has_user_id) {
                          data = (
                            <Text
                              color={"black"}
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              overflow="hidden"
                              whiteSpace="nowrap"
                              maxWidth={150}
                              width={{ sm: "80px", md: "150px" }}
                              textOverflow="ellipsis"
                            >
                              {cell.value}
                            </Text>
                          );
                        } else {
                          data = (
                            <Text
                              color={"black"}
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              overflow="hidden"
                              whiteSpace="nowrap"
                              width={{ sm: "80px", md: "150px" }}
                              maxWidth={150}
                              textOverflow="ellipsis"
                            >
                              {row.original.colleague?.name}
                            </Text>
                          );
                        }
                      } else if (
                        cell.column.Header === "ACTION" &&
                        cell.value.category === "File PDF"
                      ) {
                        const isJustPurchased =
                          justPurchasedHistoryId &&
                          row.original.product.id ===
                            justPurchasedHistoryId.productId &&
                          row.original.user_id ===
                            justPurchasedHistoryId.visitorId;
                        if (row.original.status === 1) {
                          data = (
                            <Flex flexDirection="row" gap={2}>
                              <Button
                                id={
                                  isJustPurchased
                                    ? "blinking-button"
                                    : undefined
                                }
                                bgColor={
                                  isJustPurchased ? "#8EDDBE" : "#2458EA"
                                }
                                width={"60px"}
                                color="white"
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="500"
                                borderRadius={"5px"}
                                border={
                                  isJustPurchased
                                    ? "0px solid #6C8003"
                                    : undefined
                                }
                                padding="5px 20px"
                                animation={
                                  isJustPurchased
                                    ? `${blink} 1s linear infinite`
                                    : undefined
                                }
                                onClick={() =>
                                  onClickAction({
                                    type: "Download",
                                    product: row.original,
                                    index: index,
                                  })
                                }
                                title="Download PDF"
                                _hover={{
                                  bgColor: isJustPurchased
                                    ? "#8EDDBE"
                                    : "#2458EA",
                                }}
                                _active={{
                                  bgColor: isJustPurchased
                                    ? "#8EDDBE"
                                    : "#2458EA",
                                }}
                              >
                                {loading[index] ? (
                                  <CircularProgress
                                    thickness={4}
                                    size={15}
                                    sx={{
                                      color: (theme) =>
                                        theme.palette.grey[
                                          theme.palette.mode === "light"
                                            ? 200
                                            : 800
                                        ],
                                    }}
                                  />
                                ) : (
                                  "Unduh"
                                )}
                              </Button>
                              {/* <Button
                                bgColor="green"
                                color='white'
                                fontSize={{sm: 'xs', md: 'sm'}}
                                fontWeight='500'
                                borderRadius='5px'
                                onClick={() => onClickAction({type: 'Web', product: row.original})}
                                px='11px'
                                py='9px'
                                title="Open Web View">
                                <OpenInNewIcon fontSize="sm"/>
                              </Button> */}
                            </Flex>
                          );
                        } else {
                          data = (
                            <Button
                              bgColor="#2458EA"
                              color="white"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              borderRadius="5px"
                              width="60%"
                              onClick={() =>
                                onClickAction({
                                  type: "Buy",
                                  product: row.original,
                                })
                              }
                              // px="15px"
                              py="5px"
                            >
                              Beli lagi
                            </Button>
                          );
                        }
                      } else if (
                        cell.column.Header === "ACTION" &&
                        cell.value.category !== "File PDF"
                      ) {
                        if (
                          row.values.status === 1 ||
                          moment(row.values.expired_at).isSameOrAfter(
                            new Date()
                          )
                        ) {
                          data = (
                            <Flex flexDirection="row" gap={1}>
                              <Button
                                bgColor="#2458EA"
                                color="white"
                                width="60px"
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="500"
                                borderRadius="5px"
                                onClick={() =>
                                  onClickAction({
                                    type: "Web",
                                    product: row.original,
                                  })
                                }
                                px="25px"
                                py="5px"
                              >
                                View
                              </Button>
                              {row.original.product.type === "persona" && (
                                <Flex
                                  cursor="pointer"
                                  border="2px solid #2458EA"
                                  borderRadius={5}
                                  paddingY="5px"
                                  alignItems="center"
                                  justifyContent="center"
                                  width="25px"
                                  onClick={() => onOpenDialog(row.original.id)}
                                >
                                  <CgTrash color="#2458EA" />
                                </Flex>
                              )}
                            </Flex>
                          );
                        } else {
                          data = (
                            <Flex flexDirection="row" gap={1}>
                              <Button
                                bgColor="#2458EA"
                                color="white"
                                width="60px"
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="500"
                                borderRadius="5px"
                                onClick={() =>
                                  onClickAction({
                                    type: "Buy",
                                    product: row.original,
                                  })
                                }
                                // px="15px"
                                py="5px"
                              >
                                Beli lagi
                              </Button>
                              {row.original.product.type === "persona" && (
                                <Flex
                                  cursor="pointer"
                                  border="2px solid #2458EA"
                                  borderRadius={5}
                                  paddingY="5px"
                                  alignItems="center"
                                  justifyContent="center"
                                  width="25px"
                                  onClick={() => onOpenDialog(row.original.id)}
                                >
                                  <CgTrash color="#2458EA" />
                                </Flex>
                              )}
                            </Flex>
                          );
                        }
                      } else if (
                        cell.column.Header === "MULAI" ||
                        cell.column.Header === "SELESAI" ||
                        cell.column.Header === "TGL BELI"
                      ) {
                        const color =
                          cell.column.Header === "SELESAI" &&
                          cell.value &&
                          moment(cell.value).isSameOrBefore(Date.now(), "day")
                            ? "red"
                            : "black";
                        data = (
                          <Text
                            color={color}
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="500"
                            overflow="hidden"
                            whiteSpace="nowrap"
                            maxWidth={200}
                            textOverflow="ellipsis"
                          >
                            {cell.value
                              ? moment(cell.value).format("DD MMM YYYY")
                              : "-"}
                          </Text>
                        );
                      } else if (cell.column.Header === "STATUS") {
                        data = (
                          <Text
                            color={"black"}
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="500"
                            overflow="hidden"
                            whiteSpace="nowrap"
                            maxWidth={150}
                            textOverflow="ellipsis"
                          >
                            {cell.value === 1 ? "Succeeded" : "Failed"}
                          </Text>
                        );
                      } else {
                        data = (
                          <Text
                            color={"black"}
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="500"
                            overflow="hidden"
                            whiteSpace="nowrap"
                            maxWidth={150}
                            textOverflow="ellipsis"
                          >
                            {cell.value}
                          </Text>
                        );
                      }
                      return (
                        <Td
                          {...cell.getCellProps()}
                          key={`${type}-td-${index}-${cell.value}`}
                          fontSize={{ sm: "xs", md: "sm" }}
                          minW={{ sm: "80px", md: "200px", lg: "auto" }}
                          width={{ sm: "80px", md: "150px" }}
                          borderColor="transparent"
                        >
                          {data}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
        <Flex
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="center"
          w={{ sm: "max-content", lg: "100%" }}
        >
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => firstPage(type)}
            disabled={pagination.page === 1}
          >
            {"<<"}
          </Button>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => prevPage(type)}
            disabled={pagination.page === 1}
          >
            {"<"}
          </Button>
          <Flex
            borderWidth={1}
            bg={"white"}
            borderRadius="5px"
            px="10px"
            py="5px"
            gap={2}
          >
            <Text color="#000" fontSize={{ sm: "sm", md: "md" }}>
              Page{" "}
            </Text>
            <Input
              variant="search"
              fontSize={{ sm: "xs", md: "sm" }}
              bg={"white"}
              color={"black"}
              w={10}
              fontWeight="500"
              borderRadius={5}
              textAlign="center"
              placeholder={pagination.page}
              value={pagination.page}
              onChange={(e) => {
                const page = e.target.value;
                goToPage(type, page);
              }}
            />
            <Text color="#000" fontSize="md">
              {" "}
              / {pagination.max}
            </Text>
          </Flex>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => nextPage(type)}
            disabled={pagination.page === pagination.max}
          >
            {">"}
          </Button>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => lastPage(type)}
            disabled={pagination.page === pagination.max}
          >
            {">>"}
          </Button>
          <select
            style={{ padding: "5px 10px" }}
            value={pagination.limit}
            onChange={(e) => {
              limitPage(type, Number(e.target.value));
            }}
          >
            {[1, 5, 10, 20, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <Text fontSize={{ sm: "xs", md: "sm" }}>
            {pagination.limit > pagination.total
              ? pagination.total
              : pagination.limit}{" "}
            of {pagination.total}
          </Text>
        </Flex>
      </Flex>

      <BootstrapDialog
        onClose={onCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#D5DDFC" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Apakah kamu akan menghapus User ini dari daftar List saat ini?
            </Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => onConfirmDelete()}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

export default TablePurchased;
